import {gql} from '@apollo/client'

export const GET_PAYMENT_DETAIL = gql`
  query GetPaymentDetail($paymentDetailId: ID!) {
    paymentDetail(id: $paymentDetailId) {
      id
      contentWithPlaceholders
      name
    }
  }
`

export const CREATE_PAYMENT_DETAIL = gql`
  mutation CreatePaymentDetail($contentWithPlaceholders: String, $name: String) {
    paymentDetail(contentWithPlaceholders: $contentWithPlaceholders, name: $name) {
      id
      contentWithPlaceholders
      name
    }
  }
`

export const UPDATE_PAYMENT_DETAIL = gql`
  mutation UpdatePaymentDetail($id: ID!, $contentWithPlaceholders: String, $name: String) {
    paymentDetail(id: $id, contentWithPlaceholders: $contentWithPlaceholders, name: $name) {
      id
      contentWithPlaceholders
      name
    }
  }
`
